import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
});

let isRefreshing = false;
let refreshSubscribers = [];

const refreshToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("No refresh token found!");

    try {
        const response = await axios.post(`${API_BASE_URL}/Account/RefreshToken`, { refreshToken });
        const newAccessToken = response.data.accessToken;

        localStorage.setItem("authToken", newAccessToken);

        refreshSubscribers.forEach(callback => callback(newAccessToken));
        refreshSubscribers = [];

        return newAccessToken;
    } catch (error) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        alert("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        window.location.href = "/login";
        throw new Error("Phiên đăng nhập đã hết hạn!");
    }
};

axiosInstance.interceptors.request.use(
    (config) => {
        const authToken = localStorage.getItem("authToken");
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }

        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        if (error.response?.status === 401 && !originalRequest._retry) {
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const newToken = await refreshToken();
                    isRefreshing = false;
                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    isRefreshing = false;
                    return Promise.reject(refreshError);
                }
            }

            return new Promise((resolve) => {
                refreshSubscribers.push((newToken) => {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    resolve(axiosInstance(originalRequest));
                });
            });
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;